// ======================================================================
// File Name       : ContentLinkingRegisterContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { submit, formValueSelector, getFormValues } from 'redux-form';
import ModalWrapper from '../../components/modal/ModalWrapper';
import ContentSearchForm from '../../components/contentLink/ContentSearchForm';
import ContentSelectionForm from '../../components/contentLink/ContentSelectionForm';
import * as itemActions from '../../actions/ItemAction';
import { REDIRECT_MODAL } from '../../constants/ContentLinkConstants';
import * as Path from '../../constants/PathConstants';
import * as actionType from '../../constants/actionTypes/page';

class ContentLinkingRegisterContainer extends Component {
  constructor() {
    super();

    this.state = {
      startPosition: null,
    };

    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleSearchBtn = this.handleSearchBtn.bind(this);
    this.handleNextBtnClick = this.handleNextBtnClick.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentWillMount() {
    const { initialValues } = this.props;
    this.handleSearchBtn(initialValues);
  }

  handlePageChange(startPosition) {
    const searchInfo = this.props.formValues;
    this.setState({
      startPosition,
    }, () => {
      this.props.dispatch(itemActions.searchContent({ ...searchInfo, startPosition, excludeQuestion: true }));
    });
  }

  handleSearchBtn(searchInfo) {
    const { dispatch } = this.props;
    this.setState({
      startPosition: 0,
    }, () => {
      dispatch(itemActions.searchContent({ ...searchInfo, startPosition: 0, excludeQuestion: true }));
    });
  }

  handleNextBtnClick() {
    const { contentInfo } = this.props;
    if (!contentInfo) return;

    const { dispatch, modalId } = this.props;
    const { formValues } = this.props;
    this.props.dispatch({
      type: actionType.SAVE_SEARCH_CONDITION,
      parentPath: Path.COURSE_LIST,
      searchCondition: formValues,
    });
    dispatch(itemActions.doFinishContentSelection(contentInfo));
  }

  closeModal() {
    this.props.dispatch({
      type: actionType.CLEAR_SEARCH_CONDITION,
    });
    this.props.hideModal();
  }

  getModalOptions() {
    return {
      title: 'セクションに紐付けるコンテンツを選択してください',
      footerBtns: [
        { name: 'キャンセル', onClick: this.closeModal, variant: 'default' },
        { name: '次へ', onClick: this.handleNextBtnClick, variant: 'primary' },
      ],
    };
  }

  render() {
    return (
      <ModalWrapper {...this.getModalOptions()} hideModal={this.closeModal}>
        <div>
          <div className="max-width-700">
            <ContentSearchForm onSubmit={this.handleSearchBtn} />
          </div>
          <ContentSelectionForm
            handlePageChange={this.handlePageChange}
            startPosition={this.state.startPosition}
          />
        </div>
      </ModalWrapper>
    );
  }
}

const selector = formValueSelector('contentLinkContentSelectionForm');
const mapStateToProps = (state, ownProps) => {
  const contentSecernId = selector(state, 'contentSecernId');
  const contentInfo = state.content.contents.bySecernId[contentSecernId];
  const { parentPath, searchCondition } = state.page;
  let initialValues = {};
  if (parentPath === Path.COURSE_LIST) initialValues = searchCondition;
  return {
    contentInfo,
    values: getFormValues('contentLinkContentSelectionForm')(state),
    formValues: getFormValues('contentLinkContentSearchForm')(state),
    initialValues,
  };
};

export default connect(mapStateToProps)(ContentLinkingRegisterContainer);
